var _circle, _circle2, _g, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavMobileToggle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.373,
    cy: 20,
    r: 20,
    fill: "#5797B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9493_9942",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 41,
    height: 40
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 20.373,
    cy: 20,
    r: 20,
    fill: "#C85D38"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9493_9942)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 35.6621 -12.9507)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 37.2773 -10.1543)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 38.8027 -7.5127)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 40.416 -4.71533)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 41.9434 -2.07373)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 43.5547 0.723633)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 45.082 3.36523)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 46.6953 6.16211)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 48.2246 8.80371)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 49.8359 11.6006)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 51.3652 14.2422)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 52.9766 17.0396)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 54.5059 19.6812)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 56.1172 22.478)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 57.6445 25.1201)",
    fill: "#65AACB"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1.71273,
    height: 50.24,
    transform: "matrix(0.499898 0.866085 -0.866153 0.49978 59.2578 27.9165)",
    fill: "#65AACB"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11.1055,
    y: 13.6587,
    width: 20.077,
    height: 2.61874,
    rx: 1.30937,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1055,
    y: 19.6665,
    width: 20.077,
    height: 2.61874,
    rx: 1.30937,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 11.1055,
    y: 25.6738,
    width: 20.077,
    height: 2.61874,
    rx: 1.30937,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavMobileToggle);
export default __webpack_public_path__ + "static/media/nav-mobile-toggle.517a67d6c4b651ace3d1c923d150854c.svg";
export { ForwardRef as ReactComponent };